import React from "react";
import { siteData } from "../mock";
import { Quote } from "lucide-react";

export default function About() {
  const { about } = siteData;

  return (
    <section id="about" className="relative bg-[#0a0a0a] py-24">
      <div className="absolute inset-0 bg-grid-lines opacity-30 pointer-events-none" />
      <div className="absolute top-1/2 -translate-y-1/2 -left-40 w-[500px] h-[500px] bg-red-700/20 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-14 items-start">
          {/* Left: heading */}
          <div className="lg:col-span-2">
            <p className="deal-yellow font-heading tracking-[0.3em] text-sm md:text-base mb-3">
              ABOUT
            </p>
            <h2 className="font-display text-white font-bold text-5xl md:text-6xl tracking-wide leading-none mb-8">
              {about.name}
            </h2>

            {/* Est. + Location card */}
            <div className="card-surface rounded-2xl p-8">
              <p className="deal-yellow font-heading tracking-[0.3em] text-xs mb-2">
                EST. 2013
              </p>
              <p className="font-wordmark text-white text-3xl md:text-4xl tracking-wide mb-3">
                THEDEAL FITNESS
              </p>
              <p className="text-white/75 text-base">
                10521 Croatia Way<br />
                Manassas, VA 20109<br />
                <span className="text-white/55">By appointment only</span>
              </p>
            </div>
          </div>

          {/* Right: bio */}
          <div className="lg:col-span-3">
            <div className="flex flex-wrap gap-3 mb-8">
              {about.badges.map((b, i) => (
                <span
                  key={i}
                  className="px-4 py-2 rounded-md border border-[#e10600]/40 bg-[#2a0000]/50 deal-yellow font-heading tracking-[0.2em] text-xs md:text-sm font-semibold"
                >
                  {b}
                </span>
              ))}
            </div>

            <div className="space-y-5 mb-10">
              {about.paragraphs.map((p, i) => (
                <p key={i} className="text-white/80 text-lg leading-relaxed">
                  {p}
                </p>
              ))}
            </div>

            {/* Quote */}
            <div className="card-surface rounded-xl p-8 relative">
              <Quote className="absolute -top-4 -left-2 deal-yellow" size={40} />
              <p className="font-display text-white text-2xl md:text-3xl tracking-wide leading-snug italic">
                “{about.quote}”
              </p>
              <p className="mt-4 deal-yellow font-heading tracking-[0.25em] text-sm">
                — {about.name} {about.ownerLabel ? `(${about.ownerLabel})` : ""}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
